// extracted by mini-css-extract-plugin
export var label = "_gp-2";
export var slideContainer = "_gp-0";
export var slider = "_gp-1";